module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button-component', {
    staticClass: "BackButton",
    attrs: {
      "route": _vm.route,
      "label": _vm.label
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1aedc510"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BackButton.vue
// module id = 745
// module chunks = 1474